module.exports = __webpack_public_path__ + "img/phone-receiver.6831c191.svg";